import React from 'react'
import CommonLayout from './CommonLayout';
import { Tab } from "@headlessui/react";
import StayCard from 'components/StayCard/StayCard';
import DataGrid from 'components/DataGrid';
const DirecConnects = () => {
  return (
    <div className="flex w-screen">
      <CommonLayout>
        <div
          className="nc-AccountPage flex  flex-grow w-full container "
          data-nc-id="AccountPage"
        >
          {/* <div>
            <Tab.Group>
              <Tab.Panels>
                <Tab.Panel className="">
                  <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {[1, 2, 3, 4, 5].map((transaction: any) => (
                      <StayCard
                        currentProperty={""}
                        data={""}
                        className="shadow-2xl"
                        size={"default"}
                      />
                    ))}
                  </div>

                  <div className="flex mt-11 justify-center items-center">
                    <button
                      onClick={() => ""}
                      className="nc-Button relative h-auto inline-flex items-center justify-center rounded-full transition-colors text-sm sm:text-base font-medium px-4 py-3 sm:px-6  ttnc-ButtonPrimary disabled:bg-opacity-70 bg-custom-color  text-neutral-50 blue-btn"
                    >
                      Show me more
                    </button>
                  </div>
                </Tab.Panel>
              </Tab.Panels>
            </Tab.Group>
          </div> */}
          <h1>DirektConnects</h1>
       
        </div>
      </CommonLayout>
    </div>
  );
}

export default DirecConnects;